import React from "react";

export const CounterString = ({ maxLength = 200, length }) => {
  return (
    <small className="text-sm ml-2 text-gray-500">
      Caracteres restantes: {maxLength - length ?? 0}
    </small>
  );
};
